import { isPaytechPlatform, isWolfBTCPlatform } from '@/helpers/environmentHelper';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import { useState } from 'react';
import Navbar from '../Navbar';
import UniversalSidebar from '../UniversalSidebar';
import PortalFooter from './PortalFooter';

interface PortalLayoutProps extends React.PropsWithChildren {
    isAuthorized: boolean;
}

export default function PortalLayout({ children, isAuthorized }: PortalLayoutProps) {
    const settings = useDisclosure(false);

    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <main className="portal-layout flex h-full bg-brand-background justify-center lg:divide-x-[1px] lg:divide-brand-neutral-700 overflow-y-auto border-[1.5px] lg:border-[3px] border-brand-border">
            <UniversalSidebar
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                settingsDisclosure={settings}
                isAlwaysExpanded
            />
            <Navbar settings={settings} />
            <div className="flex flex-col h-full w-full lg:pl-[260px] lg:pt-[80px]">
                {children}
                {isAuthorized && !(isPaytechPlatform || isWolfBTCPlatform) && <PortalFooter />}
            </div>
        </main>
    );
}
